// index.js

import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider, App as AntdApp } from 'antd'
import itIT from 'antd/locale/it_IT'
import dayjs from 'dayjs'
import 'dayjs/locale/it'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './styles/global.less'

// dayjs formatta nomi di giorni/mesi in italiano ovunque nell'app
// (indipendente dalla locale di Ant Design, che copre solo i suoi componenti)
dayjs.locale('it')

// Configurazione React Query
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000, // 5 minuti
            gcTime: 10 * 60 * 1000, // 10 minuti
        },
        mutations: {
            retry: 0,
        },
    },
})

// Configurazione globale per Ant Design
const antdConfig = {
    locale: itIT,
    theme: {
        token: {
            colorPrimary: '#1890ff',
            borderRadius: 8,
        },
        components: {
            Button: {
                borderRadius: 8,
            },
            Card: {
                borderRadiusLG: 12,
            },
        },
    },
}

const root = ReactDOM.createRoot(document.getElementById('app'))

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <ConfigProvider {...antdConfig}>
                <AntdApp>
                    <App />
                </AntdApp>                
            </ConfigProvider>
        </QueryClientProvider>
    </React.StrictMode>
)